import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, of, Subject, switchMap, tap } from 'rxjs';
import { FilterOperators } from 'src/app/common/enums';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { UserService } from 'src/app/data/user.service';
import { FilterType } from 'src/app/list-filter/enums/filter-type.enum';
import { FilterService } from 'src/app/list-filter/services/filter.service';
import { DictionaryItem } from 'src/app/models/dictionary-item';
import { FilterTypeEnum } from 'src/app/models/enums/filter-type-enum';

@Injectable()
export class AbsencesPerYearListFilterService extends FilterService {
  protected userService: UserService;
  private translateService = inject(TranslateService);
  private dictionaryService = inject(DictionaryService);

  protected filterType = FilterTypeEnum.AbsencesPerYearList;
  private subject: Subject<string> = new Subject<string>();
  private mpks$ = new BehaviorSubject<DictionaryItem[]>(null);


  constructor() {
    const userService = inject(UserService);

    super(FilterTypeEnum.AbsencesPerYearList, userService);
    this.userService = userService;


    this.config = [
      {
        id: 1,
        name: 'lastName',
        label: this.translateService.instant('LastName'),
        property: 'LastName',
        default: true,
        operator: FilterOperators.Contains,
        type: FilterType.Text,
      },
      {
        id: 2,
        name: 'firstName',
        label: this.translateService.instant('FirstName'),
        property: 'FirstName',
        operator: FilterOperators.Contains,
        type: FilterType.Text,
      },
      {
        id: 3,
        name: 'companyId',
        label: this.translateService.instant('Company'),
        property: 'CompanyId',
        operator: FilterOperators.Equal,
        type: FilterType.Autocomplete,
        datasource$: this.subject.asObservable().pipe(switchMap((value: string) => (value ? this.dictionaryService.getCompanies(value) : of([])))),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
      {
        id: 4,
        name: 'employerId',
        label: this.translateService.instant('Employer'),
        property: 'EmployerId',
        operator: FilterOperators.Equal,
        default: true,
        type: FilterType.Autocomplete,
        datasource$: this.subject.asObservable().pipe(switchMap((value: string) => (value ? this.dictionaryService.getEmployers(value) : of([])))),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
      {
        id: 5,
        name: 'employerObjectId',
        label: this.translateService.instant('EmployerObject'),
        property: 'EmployerObjectId',
        operator: FilterOperators.Equal,
        default: true,
        type: FilterType.SearchableMultiselect,
        getData: (value: string, page: number, pageSize: number) => this.dictionaryService.getEmployerObjectsPaged(value, page, pageSize),
        changeCallback: (value: any[]) => this.mpks$.next(value?.map((item) => ({ Id: item.Id, Name: item.Mpk })) ?? null),
      },
      {
        id: 6,
        name: 'pesel',
        label: this.translateService.instant('Pesel'),
        property: 'Pesel',
        default: true,
        operator: FilterOperators.StringEqual,
        type: FilterType.Text
      },
    ];
  }
}
